var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16 16C19.6819 16 22.6667 13.0152 22.6667 9.33333C22.6667 5.65144 19.6819 2.66667 16 2.66667C12.3181 2.66667 9.33333 5.65144 9.33333 9.33333C9.33333 13.0152 12.3181 16 16 16Z",
    stroke: "#3451F4",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.54667 29.3333C4.54667 24.1733 9.68 20 16 20C17.28 20 18.52 20.1733 19.68 20.4933",
    stroke: "#3451F4",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.3333 24C29.3333 24.4267 29.28 24.84 29.1733 25.24C29.0533 25.7733 28.84 26.2933 28.56 26.7467C27.64 28.2933 25.9467 29.3333 24 29.3333C22.6267 29.3333 21.3867 28.8133 20.4533 27.96C20.0533 27.6133 19.7067 27.2 19.44 26.7467C18.9467 25.9467 18.6667 25 18.6667 24C18.6667 22.56 19.24 21.24 20.1733 20.28C21.1467 19.28 22.5067 18.6667 24 18.6667C25.5733 18.6667 27 19.3467 27.96 20.44C28.8133 21.3867 29.3333 22.64 29.3333 24Z",
    stroke: "#3451F4",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.9867 23.9733H22.0133",
    stroke: "#3451F4",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24 22.0267V26.0133",
    stroke: "#3451F4",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupOwner);
export default __webpack_public_path__ + "static/media/popup-owner.58e32a1a9e08c5155873579f38d1b1f5.svg";
export { ForwardRef as ReactComponent };